export {default as bnpz} from './logo_bnpz.png'
export {default as ung} from './ung.png'
export {default as prev} from './prev.svg'
export {default as pdf} from './pdf.png'

